import { apiClient } from '@lib/api/client';
import type { TemplateResponse, SendGridTemplate, CafeTemplatesResponse } from '../types/template.types';

export const templateService = {
  async getTemplate(): Promise<TemplateResponse> {
    const response = await apiClient.get<TemplateResponse>('/templates');
    return response.data;
  },

  async getSendGridTemplate(templateId: string): Promise<SendGridTemplate> {
    const response = await apiClient.get<SendGridTemplate>(
      `/templates/sendgrid/${templateId}`
    );
    return response.data;
  },

  async getCafeTemplates(): Promise<CafeTemplatesResponse> {
    const response = await apiClient.get<CafeTemplatesResponse>('/templates/cafe');
    return response.data;
  },

  async updateTemplate(templateId: string, templateData: any): Promise<any> {
    const response = await apiClient.patch(`/templates/${templateId}`, templateData);
    return response.data;
  },

  async uploadLogo(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await apiClient.post<{ url: string }>('/templates/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  async uploadSignature(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('signature', file);

    const response = await apiClient.post<{ url: string }>('/templates/upload-signature', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
